import Modal from "../../layouts/Modal";
import { ISupplier } from "../../models/Supplier";
import { IVoucher } from "../../models/Voucher";
import AddEditVoucher from "./AddEditVoucher";

interface VoucherModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    voucher?: IVoucher | undefined;
    supplier?: ISupplier | undefined;
}

export default function VoucherModal({ open, setOpen, voucher, supplier }: VoucherModalProps) {
    return (
        <Modal width="max-w-3xl" open={open} setOpen={setOpen}>
            <AddEditVoucher voucher={voucher} setOpen={setOpen} supplier={supplier} />
        </Modal>
    )
}